module.exports = function getResource(label) {
    const resources = { free: 'GRATUIT' };

    return resources[label];
};
